class Showcase extends HTMLElement {
    constructor() {
        super();
        this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback () {
        // Cache nodes after connection 
        this.showcaseEntriesName = Array.from(this.querySelectorAll('.showcase-name__item'));
        this.showcaseEntriesMedia = Array.from(this.querySelectorAll('.showcase-media__item'));

        // Initial breakpoint check + listener
        this.handleResize();
        window.addEventListener('resize', this.handleResize, { passive: true });

        // Wire events
        this.showcaseEntriesName.forEach((entry) => {
            // Click for touch/mobile
            entry.addEventListener('click', (e) => {
                if (this.mobile) {
                    e.preventDefault(); // ✅ stops navigation
                    this.setActive(event.currentTarget, e);
                }
            });

            // Hover/focus for desktop
            entry.addEventListener('mouseenter', (e) => {
                if (!this.mobile) this.setActive(e.currentTarget, e);
            });

            // Keyboard accessibility
            entry.addEventListener('focus', (e) => {
                if (!this.mobile) this.setActive(e.currentTarget, e);
            });
        });

        // Optional: set initial active from first item
        if (this.showcaseEntriesName.length) {
            this.setActive(this.showcaseEntriesName[0], null);
        }
    }

    disconnectedCallback () {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize () {
        // Simple breakpoint; swap to matchMedia if preferred
        this.mobile = window.innerWidth < 1000;
    }

    setActive (showcaseEl, event) {
        if (this.mobile && event) {
            event.preventDefault();
        }
        const showcaseID = showcaseEl?.dataset?.showcaseId;
        if (!showcaseID) return;

        this.showcaseEntriesMedia.forEach((media) => {
            if (media.dataset.showcaseId === showcaseID) {
                media.classList.remove('hidden');
            } else {
                media.classList.add('hidden');
            }
        });
    }
}

customElements.define('component-showcase', Showcase);
